// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Dropdown_Wrapper__2DHJI","List":"Dropdown_List__2NG5i","Item":"Dropdown_Item__3fyb6","Link":"Dropdown_Link__7WKD1"};